module.exports = __webpack_public_path__ + "static/01-ce87a7b005c8d7be981ccd8137fcba3b.jpg";